export const isUspiAssociation = (associationId: string): boolean => {
  return associationId.includes('uspi-');
};
